import { render, staticRenderFns } from "./ArtistProfileHeader.vue?vue&type=template&id=36f8b182&scoped=true"
import script from "./ArtistProfileHeader.vue?vue&type=script&lang=js"
export * from "./ArtistProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./ArtistProfileHeader.vue?vue&type=style&index=0&id=36f8b182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8b182",
  null
  
)

export default component.exports